import { render } from "./ProductTagItem.vue?vue&type=template&id=74c5f5c3&scoped=true"
import script from "./ProductTagItem.vue?vue&type=script&lang=js"
export * from "./ProductTagItem.vue?vue&type=script&lang=js"

import "./ProductTagItem.vue?vue&type=style&index=0&id=74c5f5c3&lang=less&scoped=true"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c5f5c3"]])

export default __exports__